import React from 'react';
import PropTypes from 'prop-types';
import { Components, translate } from 'versafleet-core';
import BulkEditDropdownPanel from './dropdownPanel';

class BulkEditButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  _closeDropdown() {
    this.setState({ expanded: false });
  }

  render() {
    return (
      <div
        className="vf-task__bulk-edit"
      >
        <Components.Button
          className="vf-task__bulk-edit__button"
          hint={this.props.strings.page.buttons.edit.hint}
          iconClassName="versa-edit"
          onClick={() => this.setState(prevState => ({ expanded: !prevState.expanded }))}
        />
        {this.state.expanded ? (
          <BulkEditDropdownPanel
            ids={this.props.ids}
          />
        ) : false}
      </div>
    );
  }
}

BulkEditButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  strings: PropTypes.shape({
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        edit: PropTypes.shape({
          hint: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default translate('Task')(BulkEditButton);
